import React, { useEffect, useState } from "react";
import {
    CaretDown,
    Pencil,
    Phone,
    Plus,
    Trash,
    WarningCircle,
} from "@phosphor-icons/react";
import axiosInstance from "../../../api/axiosInstance";
import PageLoader from "../../loader/PageLoader";
import Dashboard from "../../Dashboard/Dashboard";
import { useNavigate } from "react-router-dom";
import {toast} from "react-toastify";

const AddStaff = (onComplete) => {

    // Form Data
    const [formData, setFormData] = useState({
        name: "",
        contact: "",
        department: "",
        workingTime: {
            from: "",
            // fromPeriod: "AM",
            to: "",
            // toPeriod: "PM",
        },
        days: [],
        shifts: [],
    });

    const [errors, setErrors] = useState({});
    const [showForm, setShowForm] = useState(false);
    const [staffList, setStaffList] = useState([]);
    const [editingStaffId, setEditingStaffId] = useState(null);
    const [isPageLoading, setIsPageLoading] = useState(true);
    const hotelId = localStorage.getItem("hotelId");
    const [hasData, setHasData] = useState(false);

    useEffect(() => {
        fetchStaff();
    }, [hotelId]);


    const fetchStaff = async () => {
        try {
            const response = await axiosInstance.get(
                `/api/v1/hotels/${hotelId}/staff-members`,
            );
            setStaffList(response.data.data);
            setIsPageLoading(false);
            setHasData(true);
        } catch (error) {
            console.error("Failed to fetch staff members:", error);
            setIsPageLoading(false);
            setHasData(false);
            setStaffList([]);
        }
    };

    const handleAddStaffClick = () => {
        setShowForm(true);
        setEditingStaffId(null);
        setFormData({
            name: "",
            contact: "",
            department: "",
            workingTime: {
                from: "",
                fromPeriod: "AM",
                to: "",
                toPeriod: "PM",
            },
            days: [],
            shifts: [],
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "contact") {
            const numericValue = value.replace(/\D/g, "").slice(0, 10);
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: numericValue,
            }));
        } else {
            setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
        }
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    };

    const handleWorkingTimeChange = (field, value) => {
        if (field === "from" || field === "to") {
            const sanitizedValue = value.replace(/[^\d:]/g, "");
            const timeRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9]?$/;

            setFormData((prevFormData) => ({
                ...prevFormData,
                workingTime: {
                    ...prevFormData.workingTime,
                    // [field]: sanitizedValue,
                    [field] : value,
                },
            }));

            // if (sanitizedValue && !timeRegex.test(sanitizedValue)) {
            //     setErrors((prevErrors) => ({
            //         ...prevErrors,
            //         workingTime: "Invalid time format. Use HH:MM",
            //     }));
            // } else {
            //     setErrors((prevErrors) => ({ ...prevErrors, workingTime: "" }));
            // }

        } 
        // else if (field === "fromPeriod" || field === "toPeriod") {
        //     setFormData((prevFormData) => ({
        //         ...prevFormData,
        //         workingTime: {
        //             ...prevFormData.workingTime,
        //             [field]: value,
        //         },
        //     }));
        // }
    };

    // const convertTo24Hour = (time, period) => {
    //     if (!time || !time.includes(":")) return null;

    //     const [hours, minutes] = time.split(":").map(Number);
    //     if (isNaN(hours) || isNaN(minutes)) return null;

    //     let adjustedHours = hours;

    //     if (period === "PM" && hours !== 12) {
    //         adjustedHours += 12;
    //     } else if (period === "AM" && hours === 12) {
    //         adjustedHours = 0;
    //     }

    //     return `${adjustedHours.toString().padStart(2, "0")}:${minutes
    //         .toString()
    //         .padStart(2, "0")}`;
    // };

    const TimeUtils = {
        // Convert 12-hour time to 24-hour time for comparison
        convertTo24Hour: (timeStr) => {
            if (!timeStr) return null;

            const [time, period] = timeStr.split(" ");
            const [hours, minutes] = time.split(":").map(Number);

            let adjustedHours = hours;

            if (period === "PM" && hours !== 12) {
                adjustedHours += 12;
            } else if (period === "AM" && hours === 12) {
                adjustedHours = 0;
            }

            return `${adjustedHours.toString().padStart(2, "0")}:${minutes
                .toString()
                .padStart(2, "0")}:00`;
        },

        // Convert 24-hour time back to 12-hour format with AM/PM
        convertTo12Hour: (timeStr) => {
            if (!timeStr) return { time: "", period: "AM" };

            const [hours, minutes] = timeStr.split(":").map(Number);
            let period = hours >= 12 ? "PM" : "AM";
            let displayHours = hours % 12;
            displayHours = displayHours === 0 ? 12 : displayHours;

            return {
                time: `${displayHours}:${minutes.toString().padStart(2, "0")}`,
                period,
            };
        },

        // Compare two times in 12-hour format
        isValidTimeRange: (startTime, startPeriod, endTime, endPeriod) => {
            const start24 = TimeUtils.convertTo24Hour(
                `${startTime}:00 ${startPeriod}`,
            );
            const end24 = TimeUtils.convertTo24Hour(
                `${endTime}:00 ${endPeriod}`,
            );
            return start24 < end24;
        },
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Name is required";
        if (!formData.contact) newErrors.contact = "Contact is required";
        if (!formData.department)
            newErrors.department = "Department is required";
        if (!formData.workingTime.from || !formData.workingTime.to) {
            newErrors.workingTime = "Time are required";
        }

        // const { from, to, fromPeriod, toPeriod } = formData.workingTime;
        // if (from && to) {
        //     if (!TimeUtils.isValidTimeRange(from, fromPeriod, to, toPeriod)) {
        //         newErrors.workingTime =
        //             "Enter correct time combination. 'From' time should be earlier than 'To' time.";
        //     }
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSaveStaff = async (e) => {
        e.preventDefault();
        if (validateForm()) {

            const formatTime = (time, period) => {
                if (!time) return "";
                return TimeUtils.convertTo24Hour(`${time}:00 ${period}`);
            };

            const finalFormData = {
                name: formData.name,
                contact: parseInt("91"+formData.contact),
                department: formData.department,
                shift_start_time : formData.workingTime.from,
                shift_end_time : formData.workingTime.to
                // shift_start_time: formatTime(
                //     formData.workingTime.from,
                //     formData.workingTime.fromPeriod,
                // ),
                
                // shift_end_time: formatTime(
                //     formData.workingTime.to,
                //     formData.workingTime.toPeriod,
                // ),
            
            };

            // console.log("Form Data for Staff : ",finalFormData);
            // return;

            try {
                if (editingStaffId) {
                    await axiosInstance.put(
                        `/api/v1/hotels/${hotelId}/staff-members/${editingStaffId}`,
                        finalFormData,
                    );
                } else {
                    await axiosInstance.post(
                        `/api/v1/hotels/${hotelId}/staff-members`,
                        finalFormData,
                    );
                }
                fetchStaff();
                resetForm();
            } catch (error) {
                toast.error(error?.response?.data?.message || "Some Error Occured")
                console.error("Error saving staff member:", error);
            }
        }
    };

    const handleEditClick = (staff) => {

        const parseTime = (timeString) => {
            const [time, period] = timeString.split(" ");
            const [hours, minutes] = time.split(":");
            return {
                time: `${hours}:${minutes}`,
                period: period,
            };
        };

        // const startTime = TimeUtils.convertTo12Hour(staff.shift_start_time);
        // const endTime = TimeUtils.convertTo12Hour(staff.shift_end_time);

        setFormData({
            name: staff.name,
            contact: staff.contact.toString().slice(2),
            department: staff.department,
            workingTime: {
                from: staff.shift_start_time,
                to: staff.shift_end_time,
                // from: startTime.time,
                // fromPeriod: startTime.period,
                // to: endTime.time,
                // toPeriod: endTime.period,
            },
            days: [],
            shifts: [],
        });
        setShowForm(true);
        setEditingStaffId(staff.id);
    };

    const handleDeleteClick = async (staffId) => {
        try {
            await axiosInstance.delete(
                `/api/v1/hotels/${hotelId}/staff-members/${staffId}`,
            );
            fetchStaff();
        } catch (error) {
            console.error("Error deleting staff member:", error);
        }
    };

    const resetForm = () => {
        setFormData({
            name: "",
            contact: "",
            department: "",
            workingTime: {
                from: "",
                fromPeriod: "AM",
                to: "",
                toPeriod: "PM",
            },
            days: [],
            shifts: [],
        });
        setShowForm(false);
        setEditingStaffId(null);
    };

    const navigate = useNavigate();

    const handleSubmit = async () => {
        (await hasData) && navigate("/dashboard");
    };

    return (
        <>
            {isPageLoading && <PageLoader />}
            <div className="flex">
                
                {/* Add  Edit or Delete Buttons Are Here  */}
                <div className="border-r-[1.5px] w-[50%] px-4">
                    <button
                        className={`h-[48px] ${
                            showForm
                                ? "bg-[#FFF2F2] text-[#FFBFC1] cursor-not-allowed"
                                : "bg-[#ff7378]"
                        } px-4 rounded-lg text-[16px] mb-3`}
                        onClick={handleAddStaffClick}
                        disabled={showForm}
                    >
                        Add Staff
                    </button>

                    <div className="w-full flex gap-2 flex-wrap">
                        {staffList.map((staff) => (
                            <div
                                className="border-[1.5px] border-[#939EDE] rounded-lg p-2 bg-[#EEF0FB] w-[49%]"
                                key={staff.id}
                            >
                                <p className="font-semibold text-lg">
                                    {staff.name}
                                </p>
                                <p>{staff.department}</p>
                                <div className="flex justify-end gap-1">
                                    <button
                                        className="rounded-md p-1 border-[1.5px] border-[#F5CCD3] h-[24px] w-[24px] bg-white text-[#ff7378]"
                                        onClick={() =>
                                            handleDeleteClick(staff.id)
                                        }
                                    >
                                        <Trash size={14} />
                                    </button>
                                    <button
                                        className="rounded-md p-1 border-[1.5px] border-[#BFC4CC] h-[24px] w-[24px] bg-white"
                                        onClick={() => handleEditClick(staff)}
                                    >
                                        <Pencil size={14} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    <button
                        className="mt-6 px-4 py-2 bg-[#0B22B2] text-white rounded-md absolute bottom-3 left-[19%]"
                        onClick={handleSubmit}
                    >
                        Next
                    </button>
                </div>

                {showForm && (
                    <div className="w-[50%] px-4">
                        <form onSubmit={handleSaveStaff}>

                            {/* Submit Handler */}
                            <button
                                className="h-[48px] bg-[#ff7378] w-full rounded-lg text-[16px]"
                                type="submit"
                            >
                                {editingStaffId ? "Update" : "Save"}
                            </button>
                           
                            <div className="flex flex-col gap-2 my-3">

                                {/* Name */}
                                <div>
                                    <p>Name</p>
                                    <input
                                        type="text"
                                        placeholder="Enter name"
                                        className="w-[50%] p-2 border-[1.5px] rounded-lg mt-1"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                    {errors.name && (
                                        <p className="text-[#ff7378] flex gap-1 items-center text-xs">
                                            <WarningCircle size={14} />
                                            {errors.name}
                                        </p>
                                    )}
                                </div>

                                {/* Contact */}
                                <div>
                                    <p>Contact</p>
                                    <div className="flex w-[95%] h-[40px] items-center">
                                        <div className="flex items-center rounded-lg w-full h-full">
                                            <div className="border-[#D0D2D4] border-[1.5px] p-[8px] rounded-l-lg outline-none px-3">
                                                +91
                                            </div>
                                            <div className="about-phoneField border-y-[1.5px] p-[8px] w-full border-r-[1.5px] border-[#D0D2D4] rounded-r-lg">
                                                <input
                                                    type="tel"
                                                    placeholder="Enter contact"
                                                    className="outline-none border-none w-[95%]"
                                                    name="contact"
                                                    value={formData.contact}
                                                    onChange={handleChange}
                                                    maxLength={10}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {errors.contact && (
                                        <p className="text-[#ff7378] flex gap-1 items-center text-xs">
                                            <WarningCircle size={14} />
                                            {errors.contact}
                                        </p>
                                    )}
                                </div>

                                {/* Department */}
                                <div>
                                    <p>Department</p>
                                    <input
                                        type="text"
                                        placeholder="Enter your department"
                                        className="w-full p-2 border-[1.5px] rounded-md mt-1"
                                        name="department"
                                        value={formData.department}
                                        onChange={handleChange}
                                    />
                                    {errors.department && (
                                        <p className="text-[#ff7378] flex gap-1 items-center text-xs">
                                            <WarningCircle size={14} />
                                            {errors.department}
                                        </p>
                                    )}
                                </div>

                                {/* Working Time */}
                                <div>
                                    <p>Working Time</p>
                                    <div className="w-full flex gap-2 mt-1">
                                        
                                        {/* From */}
                                        <div className="w-1/2 border-[1.5px] rounded-lg flex h-[40px] items-center">
                                            <p className="w-[25%] px-2 border-r-[1.5px] h-full flex items-center">
                                                From
                                            </p>
                                            <p className="w-[75%] text-center px-2 border-r-[1.5px] h-full flex items-center">
                                                {/* <input
                                                    type="text"
                                                    placeholder="HH:MM"
                                                    value={
                                                        formData.workingTime
                                                            .from
                                                    }
                                                    onChange={(e) =>
                                                        handleWorkingTimeChange(
                                                            "from",
                                                            e.target.value,
                                                        )
                                                    }
                                                    className="w-full text-center outline-none"
                                                    maxLength={5}
                                                /> */}
                                                <input type="time" value={formData.workingTime.from} 
                                                    onChange={(e) =>handleWorkingTimeChange(
                                                            "from",
                                                            e.target.value,
                                                        )
                                                    }
                                                    className="w-full text-center outline-none"
                                                />
                                            </p>

                                            {/* <div className="flex items-center w-[30%] gap-2 h-full px-2">
                                                <select
                                                    value={
                                                        formData.workingTime
                                                            .fromPeriod
                                                    }
                                                    onChange={(e) =>
                                                        handleWorkingTimeChange(
                                                            "fromPeriod",
                                                            e.target.value,
                                                        )
                                                    }
                                                    className="bg-transparent"
                                                >
                                                    <option value="AM">
                                                        AM
                                                    </option>
                                                    <option value="PM">
                                                        PM
                                                    </option>
                                                </select>
                                                <CaretDown weight="fill" />
                                            </div> */}
                                        </div>
                                        
                                        {/* TO */}
                                        <div className="w-1/2 border-[1.5px] rounded-lg flex h-[40px] items-center">
                                            <p className="w-[25%] px-2 border-r-[1.5px] h-full flex items-center">
                                                To
                                            </p>
                                            <p className="w-[75%] text-center px-2 border-r-[1.5px] h-full flex items-center">
                                                {/* <input
                                                    type="text"
                                                    placeholder="HH:MM"
                                                    value={
                                                        formData.workingTime.to
                                                    }
                                                    onChange={(e) =>
                                                        handleWorkingTimeChange(
                                                            "to",
                                                            e.target.value,
                                                        )
                                                    }
                                                    className="w-full text-center outline-none"
                                                    maxLength={5}
                                                /> */}
                                                <input type="time"
                                                    value={formData.workingTime.to}
                                                    onChange={(e) =>
                                                    handleWorkingTimeChange(
                                                        "to",
                                                        e.target.value)
                                                    }
                                                    className="w-full text-center outline-none"
                                                />
                                            </p>

                                            {/* <div className="flex items-center w-[30%] gap-2 h-full px-2">
                                                <select
                                                    value={
                                                        formData.workingTime
                                                            .toPeriod
                                                    }
                                                    onChange={(e) =>
                                                        handleWorkingTimeChange(
                                                            "toPeriod",
                                                            e.target.value,
                                                        )
                                                    }
                                                    className="bg-transparent"
                                                >
                                                    <option value="AM">
                                                        AM
                                                    </option>
                                                    <option value="PM">
                                                        PM
                                                    </option>
                                                </select>
                                                <CaretDown weight="fill" />
                                            </div> */}
                                        </div>

                                    </div>
                                    {errors.workingTime && (
                                        <p className="text-[#ff7378] flex gap-1 items-center text-xs">
                                            <WarningCircle size={14} />
                                            {errors.workingTime}
                                        </p>
                                    )}
                                </div>
                            
                            </div>

                        </form>
                    </div>
                )}
            </div>
        </>
    );
};

export default AddStaff;
